
<template>
    <div>
      <vs-dialog v-model="active" width="850px">
        <div class="con-form">
            <div ref="contentBoletaDocente">
                <vs-row class="cardGeneral">
                    <vs-col class="cardReportes pasos" vs-type="flex" vs-justify="center" vs-align="center" w="12"> 
                        <vs-row style="align-items: flex-start !important"> 
                            <vs-col sm="12" lg="2">
                                <div class="imgAlumno objetfit">
                                    <img :src="'/api/personas/' + personaId + '/avatar'" alt="alumno">
                                </div>
                            </vs-col>
                            <vs-col sm="12" lg="10" class="p-2">
                                <vs-row>
                                    <vs-col sm="12" lg="6">
                                        <h5>{{infoRow.alumno_name}}</h5>
                                        <p class="mb-0">Matrícula: <span> <strong>{{infoRow.alumno_matricula}}</strong></span></p>
                                        <p>Grupo Administrativo (No. Lista): <span> <strong>{{infoRow.grupo_administrativo}} ({{infoRow.no_lista}})</strong></span></p>
                                        <div class="d-flex" v-if="motivos">  
                                            <p class="mb-0" style="border: 2px solid #E67E22; border-radius: 7px; padding: 1% 2%; color: #E67E22"><strong>{{motivos}}</strong></p>
                                        </div>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                        <vs-alert color="danger" v-if="errorCalificaciones">
                            <template #title>
                                {{errorCalificaciones}}
                            </template>
                        </vs-alert>
                        <vs-alert color="danger" v-if="showSinCampoFormativo && cicloEscolar == 28">
                            <template #title>
                                No se cuenta configurado los campos formativos.
                            </template>
                        </vs-alert>
                        <vs-row class="my-4" v-if="alumnos.length">
                            <vs-col sm="12" :lg="witdthMenuCalificaciones">
                                <div :class="showOptionMenu == 'calificaciones' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('calificaciones')">
                                    <h6 class="mb-0">Calificaciones</h6>
                                </div>
                            </vs-col>
                            <vs-col v-if="nivel == 2" sm="12" :lg="witdthMenuCalificaciones">
                                <div :class="showOptionMenu == 'observaciones' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('observaciones')">
                                    <h6>Observaciones</h6>
                                </div>
                            </vs-col>
                            <vs-col sm="12" :lg="witdthMenuCalificaciones" v-if="params_configuracion && params_configuracion.conducta == 'show'">
                                <div :class="showOptionMenu == 'conducta' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('conducta')">
                                    <h6>Conducta</h6>
                                </div>
                            </vs-col>
                            <vs-col sm="12" :lg="witdthMenuCalificaciones" v-if="params_configuracion.retardos == 'show'">
                                <div :class="showOptionMenu == 'retardos' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('retardos')">
                                    <h6>Retardos</h6>
                                </div>
                            </vs-col>
                            <vs-col sm="12" :lg="witdthMenuCalificaciones" v-if="params_configuracion.faltas == 'show'">
                                <div :class="showOptionMenu == 'faltas' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('faltas')">
                                    <h6>Faltas</h6>
                                </div>
                            </vs-col>
                            <vs-col sm="12" :lg="witdthMenuCalificaciones" v-if="params_configuracion.tareas_no_hechas == 'show'">
                                <div :class="showOptionMenu == 'tareas_no_hechas' ? 'optionsCalificacionesSelect' : 'optionsCalificaciones'" @click="showMenu('tareas_no_hechas')">
                                    <h6>Tareas no hechas</h6>
                                </div>
                            </vs-col>
                        </vs-row>
                        <boleta-campo-formativo class="moveContent" v-show="showOptionMenu == 'calificaciones'" :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :institucion="parametros.institucion_id" :cicloEscolar="parametros.ciclo_id"></boleta-campo-formativo>
                        <observaciones v-if="observaciones.length" class="moveContent" v-show="showOptionMenu == 'observaciones'" :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :observaciones="observaciones"></observaciones>
                        <conducta class="moveContent" v-show="showOptionMenu == 'conducta'"  :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :institucion="parametros.institucion_id" :cicloEscolar="parametros.ciclo_id"></conducta>
                        <retardos class="moveContent" v-show="showOptionMenu == 'retardos'" :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :institucion="parametros.institucion_id" :cicloEscolar="parametros.ciclo_id"></retardos>
                        <faltas class="moveContent" v-show="showOptionMenu == 'faltas'" :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :institucion="parametros.institucion_id" :cicloEscolar="parametros.ciclo_id"></faltas>
                        <tareas-no-hechas class="moveContent" v-show="showOptionMenu == 'tareas_no_hechas'" :alumnos="alumnos" :nivel="nivel" :persona="persona" :permisos="permisos" :institucion="parametros.institucion_id" :cicloEscolar="parametros.ciclo_id"></tareas-no-hechas>
                    </vs-col>
                </vs-row>
            </div>
        </div>
      </vs-dialog>
    </div>
</template>
<script>
import alumnos from '../../api/requests/alumno'
import catalogos from '../../api/requests/catalogos.js'
import BoletaCampoFormativo from '../nuevos/landing/boleta/boleta-campo-formativo.vue'
import Observaciones from '../nuevos/landing/boleta/observaciones.vue'
import Conducta from '../nuevos/landing/boleta/conducta.vue'
import Faltas from '../nuevos/landing/boleta/faltas.vue'
import Retardos from '../nuevos/landing/boleta/retardos.vue'
import TareasNoHechas from '../nuevos/landing/boleta/tareas-no-hechas.vue'
    export default {
        props:[
            'value',
            'parametros',
            'infoRow',
            'nivel',
            'persona',
            'personaId'
        ],
      data:() => ({
        active: false,
        alumnos: [],
        nombreArchivo: '',
        motivos: '',
        params_configuracion: {},
        witdthMenuCalificaciones: '2',
        showSinCampoFormativo: false,
        errorCalificaciones: '',
        showOptionMenu:'calificaciones',
        permisos: [],
        observaciones: []
      }),
      components:{
        BoletaCampoFormativo,
        Observaciones,
        Conducta,
        Faltas,
        Retardos,
        TareasNoHechas
      },
      methods:{
        async getCalificaciones () {
            console.log('para', this.parametros)
            this.alumnos = []
                    const loading = this.$vs.loading({
                        target: this.$refs.contentBoletaDocente
                    })
            console.log('loading', loading)
            try {
                const params = {
                    "ciclo_escolar_id": this.parametros.ciclo_id,
                    "institucion_id": this.parametros.institucion_id,
                    "persona_alumno_id": this.personaId,
                    "programa_id": this.parametros.programa_id,
                    "campo_formativo": [1,2,3].includes(this.nivel) ? true : false
                }
                this.errorCalificaciones = ''
                const { data: response } = await catalogos.getCalificaciones(params) || {}
                loading.close()
                    this.getMotivos(response)
                    this.alumnos.push(response)
                    this.nombreArchivo = response.nombre
                    this.params_configuracion = response.params_configuracion
                    this.widthMenuOptions(this.params_configuracion)
                    if([1,2,3].includes(this.nivel) && this.alumnos[0].materias_promediables.campos_formativos.materias_sin_campo_formativo[0]){
                        this.showSinCampoFormativo = true
                    }else{
                        this.showSinCampoFormativo = false
                    }
                    this.getObservaciones()
            } catch (error) {
                loading.close()
                console.log(error)
                this.errorCalificaciones = error.response.data.message
                    
            }
        },
        async getObservaciones(){
            if (this.nivel == 2){
                try{
                    const params = {
                        institucion_id: this.parametros.institucion_id,
                        ciclo_escolar_id: this.parametros.ciclo_id,
                        persona_alumno_id: this.personaId
                    }
                    const {data: response} = await catalogos.getObservaciones(params)
                    const keys = Object.keys(response.periodos)
                    const obs = {
                        "matricula": response.matricula,
                        "nombre_alumno": response.nombre_alumno,
                        "periodos": Object.values(response.periodos).map((periodo, index) => {
                            return {
                                "periodo": keys[index],
                                "campos_formativos": periodo
                            }
                        })
                    }
                    this.observaciones.push(obs)

                }catch(error){
                }
            }
        },
        async getMotivos(id){
            const {data: response} = await alumnos.getEstatusAlumno()
            response.forEach(i => {
                if(i.id == id.status_alumno_id){
                    this.motivos = i.status
                }
            })
        },
        widthMenuOptions(menu){
            const values = Object.values(menu)
            const result = values.filter((word) => word == 'show');
            const valores = result.length
            if(valores == 1 && this.nivel != 2){
                this.witdthMenuCalificaciones = "12"
            }else if(valores == 1 && this.nivel == 2){
                this.witdthMenuCalificaciones = '6'
            }else if(valores == 2 && this.nivel == 2){
                this.witdthMenuCalificaciones = '4'
            }else if(valores == 3 && this.nivel == 2){
                this.witdthMenuCalificaciones = '3'
            }else if(valores == 4 && this.nivel == 2){
                this.witdthMenuCalificaciones = '3'
            }else if(valores == 5 && this.nivel == 2){
                this.witdthMenuCalificaciones = '2'
            }else if(valores == 2 && this.nivel != 2){
                this.witdthMenuCalificaciones = '6'
            }else if(valores == 3 && this.nivel != 2){
                this.witdthMenuCalificaciones = '4'
            }else if(valores == 4 && this.nivel != 2){
                this.witdthMenuCalificaciones = '3'
            }else if(valores == 5 && this.nivel != 2){
                this.witdthMenuCalificaciones = '3'
            }
        },
        showMenu(tipo){
            if(tipo == 'calificaciones'){
                this.showOptionMenu = 'calificaciones'
            }else if(tipo == 'observaciones'){
                this.showOptionMenu = 'observaciones'
            }else if(tipo == 'faltas'){
                this.showOptionMenu = 'faltas'
            }else if(tipo == 'retardos'){
                this.showOptionMenu = 'retardos'
            }else if(tipo == 'faltas'){
                this.showOptionMenu = 'faltas'
            }else if(tipo == 'conducta'){
                this.showOptionMenu = 'conducta'
            }else if(tipo == 'tareas_no_hechas'){
                this.showOptionMenu = 'tareas_no_hechas'
            }
        },

      },
      watch:{
        value (val) {
            this.active = val
        },      
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        personaId(){
            this.getCalificaciones()
        }
      }
    }
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }

    .imgAlumno{
        border-radius: 20%;
    }

    .imgAlumno img{
        width: 90%;
        margin-left: 3%;
        border-radius: 10px;
    }

    .logoInstitucion{
        width: 50%;
        background-color: blue;
        position: absolute;
        bottom: -25px;
        right: -30px;
	    border-radius: 50%;
    }

    .logoInstitucion > img{
        width: 100%;
        height: 80px;
        object-fit: cover;
    }
    

    .tablePDF{
        width: 100%;
        thead{
            border-bottom: 1px solid #F2F3F4;
            background: #F2F3F4;
        }
        // thead tr th{
        //     padding: 4px 0;
        // }

        tbody tr{
            border-bottom: 1px solid rgb(207, 207, 207);
        }
        tbody tr td{
            padding: 3px;
        }
        .centrarTexto{
            text-align: center;
        }

    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 20px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
.circleSize{
    font-size: 6px;
}
.obser{
    border-left: #D7DBDD;
    background: white;
}
.obser ul{
    list-style: none;
    li{
        border-bottom: 1px solid #F2F3F4;
        padding: 5px 3px;
        font-size: 9px;
    }
}

.divisorObs{
    border-bottom: 1px solid #7B7D7D;
    padding:2px;
}

.optionsCalificacionesSelect{
    color: #2874A6;
    border-bottom: 1px solid #2874A6;
    padding: 0.3rem;
    text-align: center;
    cursor:pointer;
    h6{
        margin-bottom: 0;
    }
}
.optionsCalificaciones{
    color: #CACFD2;
    background: #F2F3F4;
    padding: 0.3rem;
    text-align: center;
    cursor:pointer;
    h6{
        margin-bottom: 0;
    }
}
</style>
<style scoped>
    .objetfit > img{
        width: 150px;
        height: 150px;
        object-fit: cover;
    }
    .pasos .md-steppers .md-steppers-navigation {
        box-shadow: none !important;
        color: red;
    }

    .vs-checkbox-label{
        margin-bottom: 0 !important;
    }
    input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: auto;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }
  
.pdfLetra{
    font-size: 9px;
    margin: 0;
    color: black;
}

.pdfLetraCalif{
    font-size: 11px;
    margin: 0;
    color: black;
}

.opcionPrincipalPDF{
    background: #E5E7E9;
    padding: 3px 5px;
}

.imgLogos img{
    width: 70%;
}

#footerBoleta {
   position:absolute;
   left:0px;
   bottom:0px;
   height:30px;
   width:100%;
   background:#999;
}

.materiasBorder{
    border: solid 1px #ccc;
}

.moveContent{
    animation-duration: 0.4s;
    animation-name: slidein;
}
@keyframes slidein {
  from {
    margin-left: 100%;
    width: 300%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}

</style>

        